import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import functionsService from '@/services/functionsService';
import get from 'lodash/get';
export default {
  name: 'IsFMFavaccessmgmt',
  props: {
    item: {
      type: Object,
      required: true
    },
    tileSizeSetting: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      loader: null,
      loading: false,
      value: 0,
      interval: {},
      isfmaccess: null,
      imgsrc: './img/transponder.png',
      avatarLoader: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    dsize() {
      if (this.tileSizeSetting === 1) {
        return '-big';
      }
      return '';
    }
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => this[l] = false, 11500);
      this.loader = null;
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    this.digitalTwinGetData();
  },
  methods: {
    keyTwinTitle(item) {
      return `${get(item, 'dtwinData.title')} (${get(item, 'parentData.title')})`;
    },
    processDoor(isfmaccessid) {
      this.loader = 'loading';
      this.avatarLoader = true;
      this.value = 0;
      ApiService.isFmAccessActivateLock({
        id: isfmaccessid
      }).then(() => {
        this.$snack(this.$i18n_t('IS.FM.AccessMgmt.doorActivated'), 'success');
      }).catch(error => {
        let userRights = functionsService.userAccessRightHandling(error.response.data.data, this);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(`${userRights} - ${this.$i18n_t('IS.FM.AccessMgmt.doorFailed')}`, 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
      this.interval = setInterval(() => {
        if (this.value >= 100) {
          this.avatarLoader = false;
          this.endIntervall();
        }
        this.value += 17;
      }, 1000);
    },
    endIntervall() {
      clearInterval(this.interval);
    },
    digitalTwinGetData() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      ApiService.isFmAccessGet(this, this.item.objectId).then(data => {
        this.isfmaccess = data;
        if (!data || !data.id) {
          this.$emit('invalid');
        }
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.errorLoadingData'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    }
  }
};